var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.977 6.115c.218-1.41-1.122-2.522-2.376-1.972L2.638 15.103c-.898.395-.833 1.757.1 2.053l5.148 1.64a3.32 3.32 0 0 0 2.904-.442l11.606-8.018c.35-.242.732.255.433.564l-8.355 8.613c-.81.836-.65 2.252.325 2.863l9.354 5.865c1.05.658 2.399-.003 2.595-1.27z"
  })));
};
export default SvgTelegram;